<template>
  <div class="product-form">
    <Dialog
      :visible.sync="show"
      :containerStyle="{ width: $isMobile() ? '100vw' : '40vw' }"
      :maximizable="true"
      :modal="true"
      v-on:hide="cancel"
      v-on:show="
        () => {
          $validator.resume();
        }
      "
      :header="form.id ? 'Editar Produto' : 'Novo Produto'"
    >
    <Loading
        :active.sync="loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <form
        class="p-col-12"
        @submit.prevent="submitForm"
        style="min-height: 60vh"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12 p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2 p-mt-2">
              <div class="p-field p-col-12 p-md-12">
                <span
                  class="p-float-label"
                  style="top: -0.75rem; left: -0.5rem; font-size: 12px"
                >
                  <label for="active">Ativa</label>
                </span>
                <InputSwitch
                  v-model="form.active"
                  :name="'active'"
                  :id="'active'"
                  style="top: 4px;"
                />
              </div>
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-2">
              <div class="p-field p-col-12 p-md-12">
                <span
                  class="p-float-label"
                  :style="{ top: '-0.75rem', left: '-0.5rem', fontSize: '12px', width: '110px' }"
                >
                  <label for="show_website">Mostrar na loja</label>
                </span>
                <InputSwitch
                  v-model="form.show_website"
                  :name="'show_website'"
                  :id="'show_website'"
                  style="top: 4px;"
                />
              </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <span class="p-float-label">
              <InputText
                :id="'reference'"
                :name="'reference'"
                autocomplete="off"
                maxlength="60"
                v-validate="'required'"
                v-model="form.reference"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('reference'),
                  },
                  'form-control',
                ]"
              />
              <label for="reference">Referência do Produto</label>
            </span>
            <small v-if="errors.has('reference')" class="p-error" role="alert">
              Referência do Produto é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <span class="p-float-label">
              <Dropdown
                :name="'productFamily'"
                :id="'productFamily'"
                :filter="true"
                :showClear="true"
                dataKey="id"
                v-model="form.family_id"
                :options="productFamily"
                optionLabel="name"
                optionValue="id"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('productFamily'),
                  },
                  'form-control',
                ]"
              />
              <label for="productFamily">Familia do Produto</label>
            </span>
            <small
              v-if="errors.has('productFamily')"
              class="p-error"
              role="alert"
            >
              Familia do Produto é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Textarea
                :id="'description'"
                :name="'description'"
                maxlength="200"
                autocomplete="off"
                v-validate="'required'"
                v-model="form.description"
                :autoResize="true"
                rows="1"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('description'),
                  },
                  'form-control',
                ]"
              />
              <label for="description">Descrição Curta</label>
            </span>
            <small
              v-if="errors.has('description')"
              class="p-error"
              role="alert"
            >
              Descrição Curta é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Textarea
                :id="'long_description'"
                :name="'long_description'"
                autocomplete="off"
                v-validate="'required'"
                v-model="form.long_description"
                :autoResize="true"
                rows="1"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('long_description'),
                  },
                  'form-control',
                ]"
              />
              <label for="long_description">Descrição Detalhada</label>
            </span>
            <small
              v-if="errors.has('long_description')"
              class="p-error"
              role="alert"
            >
              Descrição Detalhada é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-3 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                :id="'cost_price'"
                :name="'cost_price'"
                mode="currency"
                :disabled="form.id"
                currency="EUR"
                locale="pt-PT"
                v-validate="'required'"
                v-model="form.cost_price"
                @input="updateMargin"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('cost_price'),
                  },
                  'form-control',
                ]"
              />
              <label for="cost_price">Preço de Custo</label>
            </span>
            <small v-if="errors.has('cost_price')" class="p-error" role="alert">
              Preço de Custo é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-3 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                :id="'sale_price'"
                :name="'sale_price'"
                mode="currency"
                currency="EUR"
                locale="pt-PT"
                v-validate="'required'"
                @input="updateMargin"
                v-model="form.sale_price"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('sale_price'),
                  },
                  'form-control',
                ]"
              />
              <label for="sale_price">Preço de Venda</label>
            </span>
            <small v-if="errors.has('sale_price')" class="p-error" role="alert">
              Preço de Venda é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-2 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                :id="'sales_margin'"
                :name="'sales_margin'"
                suffix=" %"
                locale="pt-PT"
                v-validate="'required'"
                v-model="form.sales_margin"
                @input="updateSalesPrice"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('sales_margin'),
                  },
                  'form-control',
                ]"
              />
              <label for="sales_margin">Margem Venda</label>
            </span>
            <small
              v-if="errors.has('sales_margin')"
              class="p-error"
              role="alert"
            >
              Margem de Venda é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-2 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                :id="'stock'"
                :disabled="isLgProduct"
                :name="'stock'"
                locale="pt-PT"
                v-validate="'required'"
                v-model="form.stock"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('stock'),
                  },
                  'form-control',
                ]"
              />
              <label for="stock">Stock</label>
            </span>
            <small v-if="errors.has('stock')" class="p-error" role="alert">
              Stock é obrigatório
            </small>
          </div>
          <div class="p-field p-col-12 p-md-2 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                :id="'remote_stock'"
                :name="'remote_stock'"
                :disabled="isLgProduct"
                locale="pt-PT"
                v-validate="'required'"
                v-model="form.remote_stock"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('remote_stock'),
                  },
                  'form-control',
                ]"
              />
              <label for="remote_stock">Stock Remoto</label>
            </span>
            <small
              v-if="errors.has('remote_stock')"
              class="p-error"
              role="alert"
            >
              Stock Remoto é obrigatório.
            </small>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                id="taxGroup"
                v-model="form.tax_group_id"
                :options="taxRuleGroups"
                optionValue="id"
                optionLabel="name"
                :filter="true"
                :showClear="true"
                :appendTo="'body'"
              />
              <label for="taxGroup">Grupo de Taxa (PrestaShop)</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <InputNumber
                id="weight"
                name="weight"
                mode="decimal"
                :min="0"
                :minFractionDigits="3"
                :maxFractionDigits="3"
                :useGrouping="false"
                locale="pt-PT"
                v-model="form.weight"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('weight'),
                  },
                  'form-control',
                ]"
              />
              <label for="weight">Peso (kg)</label>
            </span>
          </div>
          <div class="p-field p-col-12 p-mt-3">
            <label style="font-weight: 600; display: block; margin-bottom: 6px;">Galeria do Produto</label>
            <div v-if="form.images && form.images.length > 0" class="p-d-flex p-flex-wrap p-ai-center p-jc-start p-mb-3">
              <div
                v-for="(image, imageIndex) in form.images"
                :key="image.id || imageIndex"
                class="product-image-card p-mr-3 p-mb-2"
              >
                <div class="image-wrapper">
                  <AuthenticatedImage
                    :file="image"
                    :alt="`Imagem ${imageIndex + 1} do Produto`"
                    height="100"
                  />
                  <Button
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-danger p-button-sm individual-delete-btn"
                    @click="removeSingleProductImage(image, imageIndex)"
                    type="button"
                    v-tooltip="'Remover esta imagem'"
                  />
                </div>
                <small class="image-position-label">
                  {{ imageIndex === 0 ? "★ Capa" : `Posição ${imageIndex + 1}` }}
                </small>
              </div>
            </div>

            <div v-if="!form.images || form.images.length < 10">
              <FileUpload
                ref="productImage"
                name="productImage[]"
                accept="image/gif,image/jpg,image/jpeg,image/pjpeg,image/png,image/x-png,image/webp"
                invalidFileTypeMessage="Ficheiro inválido. Apenas aceita GIF, JPG, JPEG, PNG ou WebP"
                invalidFileSizeMessage="{0}: excede o limite de {1}."
                :maxFileSize="4194304"
                :previewWidth="100"
                :multiple="true"
                :fileLimit="10 - (form.images ? form.images.length : 0)"
                :showUploadButton="false"
                :showCancelButton="false"
              >
                <template #empty>
                  <div class="drag-drop-files">
                    <p>{{ form.images && form.images.length > 0 ? "Adicionar mais imagens ao produto" : "Arraste imagens do produto ou clique para selecionar" }}</p>
                    <small style="color: #6c757d;">(Pode selecionar imagens com máx. 4 MB cada. Formatos: JPEG, PNG, GIF, WebP)</small>
                  </div>
                </template>
              </FileUpload>
            </div>
            <small v-else style="color: #6c757d; font-style: italic;">
              Limite máximo de 10 imagens atingido para este produto.
            </small>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-sm p-button-success"
          @click="submitForm()"
          :disabled="loading"
        />
        <Button
          :label="'Cancelar'"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="cancel()"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import sparsService from "../../services/spars.service";
import AuthenticatedImage from "../elements/AuthenticatedImage.vue";
export default {
  name: "SparsProductsForm",
  props: ["show", "product"],
  components: {
    AuthenticatedImage,
  },
  watch: {
    async show() {
      if (this.show === true) {
        if (this.product) {
          this.form = { ...this.product };
          this.form.active = this.product.active === 1;
          this.form.show_website = this.product.show_website === 1;
          this.form.cost_price = parseFloat(this.product.cost_price);
          this.form.sale_price = parseFloat(this.product.sale_price);
          this.form.sales_margin = parseFloat(this.product.sales_margin);
          this.form.tax_group_id = this.product.tax_group_id;
          this.form.weight = this.product.weight !== null && this.product.weight !== undefined ? parseFloat(this.product.weight) : 0;
        }
      }
    },
  },
  computed: {
    isLgProduct() {
      return this.product && this.product.family && this.product.family.origin === 'LG';
    }
  },
  data() {
    return {
      loading: false,
      productFamily: [],
      taxRuleGroups: [],
      form: {
        id: null,
        reference: null,
        description: null,
        long_description: null,
        family_id: null,
        active: null,
        show_website: null,
        sales_margin: null,
        cost_price: null,
        sale_price: null,
        stock: null,
        remote_stock: null,
        last_price_update: null,
        website_update: null,
        tax_group_id: null,
        weight: 0,
        images: [],
      },
    };
  },
  async created() {
    this.loading = true;
    this.productFamily = await sparsService.getProductFamiliesByStatus(1);
    const taxGroupsResponse = await sparsService.getTaxRuleGroups();
    this.taxRuleGroups = taxGroupsResponse?.tax_rule_groups || [];
    this.loading = false;
  },
  deactivated() {
    this.cancel();
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    reset() {
      this.$validator.pause();
      this.$validator.reset();
      this.form = {
        id: null,
        reference: null,
        description: null,
        long_description: null,
        family_id: null,
        active: null,
        show_website: null,
        sales_margin: null,
        cost_price: null,
        sale_price: null,
        stock: null,
        remote_stock: null,
        last_price_update: null,
        website_update: null,
        tax_group_id: null,
        weight: 0,
        images: [],
      };
      if (this.$refs.productImage) {
        this.$refs.productImage.clear();
      }
    },
    cancel() {
      this.reset();
      return this.$emit("cancel");
    },
    submitForm() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }
        this.loading = true;
        if (this.form.id) {
          return this.saveEdit();
        }
        return this.saveNew();
      });
    },
    getFormParams() {
      const productImageRef = this.$refs.productImage;
      const hasFiles = productImageRef && productImageRef.files && productImageRef.files.length > 0;

      if (hasFiles) {
        let formData = new FormData();
        formData.append("reference", this.form.reference || "");
        formData.append("description", this.form.description || "");
        formData.append("long_description", this.form.long_description || "");
        formData.append("family_id", this.form.family_id || "");
        formData.append("active", this.form.active ? 1 : 0);
        formData.append("cost_price", this.form.cost_price !== null ? this.form.cost_price : "");
        formData.append("stock", this.form.stock !== null ? this.form.stock : "");
        formData.append("remote_stock", this.form.remote_stock !== null ? this.form.remote_stock : "");
        formData.append("sale_price", this.form.sale_price !== null ? this.form.sale_price : "");
        formData.append("sales_margin", this.form.sales_margin !== null ? this.form.sales_margin : "");
        formData.append("show_website", this.form.show_website ? 1 : 0);
        formData.append("tax_group_id", this.form.tax_group_id !== null ? this.form.tax_group_id : "");
        formData.append("weight", this.form.weight !== null && this.form.weight !== undefined ? this.form.weight : 0);
        for (let i = 0; i < productImageRef.files.length; i++) {
          formData.append("images[]", productImageRef.files[i]);
        }
        formData.append("image", productImageRef.files[0]);
        return formData;
      } else {
        return {
          reference: this.form.reference,
          description: this.form.description,
          long_description: this.form.long_description,
          family_id: this.form.family_id,
          active: this.form.active ? 1 : 0,
          cost_price: this.form.cost_price,
          stock: this.form.stock,
          remote_stock: this.form.remote_stock,
          sale_price: this.form.sale_price,
          sales_margin: this.form.sales_margin,
          show_website: this.form.show_website ? 1 : 0,
          tax_group_id: this.form.tax_group_id,
          weight: this.form.weight !== null && this.form.weight !== undefined ? this.form.weight : 0,
        };
      }
    },
    saveNew() {
      this.loading = true;

      return sparsService.newProduct(this.getFormParams()).then((response) => {
        this.loading = false;
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao adicionar produto",
            life: 3000,
          });
        }
        this.$emit("productAdded", response);
        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Produto adicionado com sucesso",
          life: 3000,
        });
        return this.reset();
      });
    },
    saveEdit() {
      this.loading = true;
      return sparsService
        .updateProduct(this.form.id, this.getFormParams())
        .then((response) => {
          this.loading = false;
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro ao atualizar produto",
              life: 3000,
            });
          }
          this.$emit("productUpdated", response);
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Produto atualizado com sucesso",
            life: 3000,
          });
          return this.reset();
        });
    },
    removeSingleProductImage(image, imageIndex) {
      this.$confirm.require({
        header: "Remover Imagem",
        message: `Tem a certeza que pretende remover ${imageIndex === 0 ? "a imagem de capa" : "esta imagem"} do produto?`,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: async () => {
          this.loading = true;
          try {
            const response = await sparsService.deleteGalleryImage("product", image.id);
            if (!response) {
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: "Ocorreu um erro ao remover a imagem.",
                life: 3000,
              });
              return;
            }
            this.$toast.add({
              severity: "success",
              summary: "Sucesso",
              detail: "Imagem removida com sucesso",
              life: 3000,
            });
            this.form.images.splice(imageIndex, 1);
            if (this.form.id) {
              const updated = await sparsService.getProduct(this.form.id);
              if (updated && updated.images) {
                this.form.images = updated.images;
              }
              this.$emit("productUpdated", updated || this.form);
            }
          } catch (error) {
            console.error(error);
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro de rede ao remover a imagem.",
              life: 3000,
            });
          } finally {
            this.loading = false;
          }
        },
        reject: () => {
          return;
        },
      });
    },
    removeProductImage() {
      this.$confirm.require({
        header: "Remover Imagem",
        message: "Tem a certeza que pretende remover a imagem deste produto?",
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          this.loading = true;
          return sparsService
            .removeProductImage(this.form.id)
            .then((response) => {
              if (!response) {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: "Ocorreu um erro ao remover a imagem.",
                  life: 3000,
                });
                return;
              }
              this.$toast.add({
                severity: "success",
                summary: "Sucesso",
                detail: "Imagem removida com sucesso",
                life: 3000,
              });
              this.form.images = [];
              this.$emit("productUpdated", response);
            })
            .catch((error) => {
              console.error(error);
              this.$toast.add({
                severity: "error",
                summary: "Erro",
                detail: "Erro de rede ao remover a imagem.",
                life: 3000,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        },
        reject: () => {
          return;
        },
      });
    },
    updateMargin() {
      if (this.form.cost_price > 0 && this.form.sale_price > 0) {
        const margin = ((this.form.sale_price - this.form.cost_price) / this.form.sale_price) * 100;
        this.form.sales_margin = parseFloat(margin.toFixed(2));
      } else {
        this.form.sales_margin = 0;
      }
    },

    updateSalesPrice() {
      if (this.form.cost_price != null && this.form.sales_margin != null) {
        if (this.form.sales_margin >= 100) return;
        const price = this.form.cost_price / (1 - this.form.sales_margin / 100);
        this.form.sale_price = parseFloat(price.toFixed(2));
      }
    },
  },
};
</script>

<style scoped>
.product-image-card {
  text-align: center;
  position: relative;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 6px;
  background: #f8f9fa;
}
.image-wrapper {
  position: relative;
  display: inline-block;
}
.individual-delete-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
}
.image-position-label {
  display: block;
  margin-top: 4px;
  font-weight: 500;
  color: #495057;
}
</style>
